



document.addEventListener("DOMContentLoaded", function() {
    var links = document.querySelectorAll('a');
    links.forEach(function(link) {
        link.removeAttribute('target');
    });
});


document.addEventListener("DOMContentLoaded", function() {
    // Select all anchor elements with href="tel:+19173830636"
    var links = document.querySelectorAll('a[href="tel:+19173830636"]');
    
    // Iterate over the NodeList of links
    links.forEach(function(link) {
        // Change the href attribute to "sms:+19173830636"
        link.setAttribute('href', 'sms:+19173830636');
    });
});


document.addEventListener("DOMContentLoaded", function() {


  
    // Select all anchor elements
    var links = document.querySelectorAll('a');

    // Iterate over each link
    links.forEach(function(link) {
        var href = link.getAttribute('href');
        if (href && (href.includes('instagram.com') || href.includes('tiktok.com') || href.includes('facebook.com') || href.includes('twitter.com') || href.includes('apple.com') || href.includes('play.google.com'))) {
            link.setAttribute('target', '_blank');
        }
    });
});

